let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gNn1a")).then(() => parcelRequire('7WEsL'));